module.exports = __webpack_public_path__ + "media/images/v2/t-thumb1-052aff919ada70716502f409d5528926.png";